"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function TheStack() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    number: "01",
    title: "WEEKLY WORKSHOPS",
    description: "Hands-on sessions covering everything from web development frameworks to low-level systems programming."
  }, {
    number: "02",
    title: "DISCORD CHANNELS",
    description: "24/7 community support, code reviews, and collaborative debugging sessions with fellow builders."
  }, {
    number: "03",
    title: "PROJECT NIGHTS",
    description: "Dedicated space and time to build your passion projects alongside a community of like-minded developers."
  }, {
    number: "04",
    title: "OPEN-SOURCE TOOLKIT",
    description: "Access our curated monthly repository of starter templates, documentation, and essential dev utilities."
  }];
  return <section data-section-id="2720" id="the-stack" ref={sectionRef} className="bg-background text-foreground py-24 md:py-36 lg:py-44 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div className={`lg:col-span-7 relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-lg" style={{
            boxShadow: "16px 16px 0 0 hsl(270 100% 64%)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/code_hub_workspace.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/code_hub_workspace.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/code_hub_workspace.webp-wvc-sizes" alt="Code Hub community workspace and hardware setup" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5] rounded-lg" />
              {}
              <div className="absolute top-0 left-0 flex items-center gap-2 p-4 md:p-6">
                <span className="inline-block w-2 h-2 bg-primary" />
                <span className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase text-primary-foreground bg-primary px-2 py-1 rounded-md">
                  Hub / Active
                </span>
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 lg:pt-4 transition-all duration-1000 delay-150 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="inline-block w-8 h-px bg-primary" />
              <p className="font-mono text-xs md:text-sm tracking-[0.25em] uppercase text-muted-foreground">COMMUNITY AMENITIES</p>
            </div>

            {}
            <h2 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold leading-[0.95] tracking-tight mb-4">
              Tools for
              <br />
              <span className="font-serif italic font-light text-primary">
                builders.
              </span>
            </h2>

            <p className="font-default text-base md:text-lg text-muted-foreground leading-relaxed mb-12 max-w-md">
              Code Hub provides the infrastructure, community, and resources you need to turn your technical ideas into reality.
            </p>

            {}
            <div className="flex flex-col">
              <Separator className="bg-border" />
              {features.map((feature, i) => <div key={feature.number} data-index={i} className="group cursor-default">
                  <div className="flex items-start gap-5 md:gap-7 py-6 md:py-7 transition-all duration-300 ease-out group-hover:pl-1">
                    {}
                    <div className="shrink-0">
                      <span className="font-default font-bold text-4xl md:text-5xl leading-none tabular-nums transition-colors duration-300 text-foreground group-hover:text-primary">
                        {feature.number}
                      </span>
                    </div>

                    {}
                    <div className="self-stretch w-px shrink-0 bg-primary" aria-hidden="true" />

                    {}
                    <div className="flex-1 min-w-0">
                      <h3 className="font-default text-sm md:text-base font-semibold tracking-[0.15em] uppercase text-foreground mb-2">
                        {feature.title}
                      </h3>
                      <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                  <Separator className="bg-border" />
                </div>)}
            </div>

            {}
            <div className="mt-10 flex items-center gap-3">
              <span className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">
                Code Hub / Toolkit
              </span>
              <span className="flex-1 h-px bg-border" />
              <span className="font-mono text-xs tracking-[0.2em] uppercase text-foreground">
                v1.0
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}